(function($) {
    'use strict';

    window.ProprioLocation = window.ProprioLocation || {};

    window.ProprioLocation.onGoogleMapReady = function () {
        setTimeout(function () {
            $(window).trigger('google-map-ready');
        }, 50);
    };

})(require('jquery'));
